import * as S from "./AlertTemplate.style";

interface AlertTemplateProps {
  alert?: boolean;
  children?: React.ReactElement;
  noticeButton?: React.ReactElement;
}

export const AlertTemplate = ({
  alert,
  children,
  noticeButton,
}: AlertTemplateProps) => {
  return (
    <S.AlertTemplate $alert={alert ? alert : false}>
      <S.AlertContent>{children}</S.AlertContent>
      {noticeButton && noticeButton}
    </S.AlertTemplate>
  );
};
